import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, Stack } from '@mui/material';
import { Add } from '@mui/icons-material';
import { sxConfig } from './workspace.style';
import { AutoCompleteSelectUI, FormLabelUI } from '../../Interface';
import { WorkspacePage } from './WorkspacePage';
import OverviewPage from './OverviewPage';
import { useWorkspace } from '../../../hooks/useWorkspace';
import CreateWorkspaceDialog from './CreateWorkspaceDialog/CreateWorkspaceDialog';

export const WorkspaceMain = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const workspaceState = useWorkspace();
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [createWorkspaceDialogOpen, setCreateWorkspaceDialogOpen] = useState(false);

  useEffect(() => {
    if (projectId && !workspaceState.isLoading) setSelectedProjectId(parseInt(projectId));
  }, [projectId, workspaceState.isLoading]);

  return (
    <>
      <Box sx={sxConfig.page}>
        <Stack alignItems="center" mb={2}>
          <Box width={400}>
            <AutoCompleteSelectUI
              label={<FormLabelUI text="Keresés" />}
              variant="outlined"
              size="small"
              dataset={workspaceState.autoCompleteOptions.project}
              selectedValue={selectedProjectId}
              onChange={(_e, newVal) => {
                setSelectedProjectId(newVal?.value ?? null);

                if (projectId) {
                  navigate('/app/workspace', { replace: true });
                }
              }}
            />
          </Box>
        </Stack>
        {!selectedProjectId && (
          <Box mb={2}>
            <Button variant="contained" startIcon={<Add />} onClick={() => setCreateWorkspaceDialogOpen(true)}>
              Új adatlap
            </Button>
          </Box>
        )}
        {selectedProjectId ? (
          <WorkspacePage workspaceState={workspaceState} selectedProjectId={selectedProjectId} />
        ) : (
          <OverviewPage setSelectedProjectId={setSelectedProjectId} workspaceState={workspaceState} />
        )}
      </Box>
      <CreateWorkspaceDialog
        open={createWorkspaceDialogOpen}
        handleClose={() => setCreateWorkspaceDialogOpen(false)}
        workspaceState={workspaceState}
        setSelectedProjectId={setSelectedProjectId}
      />
    </>
  );
};
